import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { LogoMark } from "@/components/Logo";
import IndiaMarketIntelligence from "@/pages/IndiaMarketIntelligence";
import ClientIntelligenceBrief from "@/pages/ClientIntelligenceBrief";
import BriefInbox from "@/pages/BriefInbox";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  componentDidCatch(error) {
    console.error(error);
  }
  render() {
    if (this.state.err) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-ink p-8">
          <div className="max-w-md border border-gold/25 bg-abyss p-10 text-center">
            <LogoMark className="mx-auto h-10 w-10" />
            <h1 className="mt-6 font-display text-2xl text-ivory">
              Something interrupted this dossier.
            </h1>
            <p className="mt-3 text-sm text-mist">Reload the page to continue.</p>
            <button
              onClick={() => { this.setState({ err: false }); window.location.reload(); }}
              className="btn-gold mt-8"
              data-testid="error-reload-button"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function useLenis() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = undefined;
    };
  }, []);
}

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useLenis();
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Navigate to="/india-market-intelligence" replace />} />
          <Route path="/india-market-intelligence" element={<IndiaMarketIntelligence />} />
          <Route path="/client-intelligence-brief" element={<ClientIntelligenceBrief />} />
          <Route path="/brief-inbox" element={<BriefInbox />} />
          <Route path="*" element={<Navigate to="/india-market-intelligence" replace />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
